(function () {
  if (window.__blusafeCompatibilityCheckerLoaded) return;
  window.__blusafeCompatibilityCheckerLoaded = true;

  var rulesCache = {};

  function fetchJson(url) {
    if (!url) return Promise.resolve(null);
    if (!rulesCache[url]) {
      rulesCache[url] = fetch(url, { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('Could not load compatibility rules');
        return response.json();
      });
    }
    return rulesCache[url];
  }

  function readJson(root, selector, fallback) {
    var node = root.querySelector(selector);
    if (!node) return fallback;
    try {
      return JSON.parse(node.textContent || 'null') || fallback;
    } catch (error) {
      return fallback;
    }
  }

  function clear(node) {
    while (node && node.firstChild) node.removeChild(node.firstChild);
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (typeof text === 'string') node.textContent = text;
    return node;
  }

  function track(eventName, payload) {
    var detail = payload || {};
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, detail));

    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try {
        window.Shopify.analytics.publish(eventName, detail);
      } catch (error) {
        // Shopify analytics is optional in the theme editor and some storefront contexts.
      }
    }
  }

  function statusCopy(status) {
    if (status === 'compatible') return 'Good news - this should fit your door.';
    if (status === 'probably_compatible') return 'This looks like a fit, but one detail needs checking.';
    if (status === 'not_compatible') return 'This product is not right for your door.';
    return 'Not sure? Send us photos and we will check for you.';
  }

  function statusLabel(status) {
    if (status === 'compatible') return 'Fits your door';
    if (status === 'probably_compatible') return 'Check one detail';
    if (status === 'not_compatible') return 'Try this instead';
    return 'Send photos';
  }

  function mediaFrame(images, key, altText) {
    var frame = el('span', 'blusafe-compatibility__media');
    var src = key ? (images || {})[key] : null;
    if (src) {
      var img = document.createElement('img');
      img.src = src;
      img.alt = altText || '';
      img.loading = 'lazy';
      frame.appendChild(img);
    } else {
      frame.className += ' blusafe-compatibility__media--empty';
      frame.innerHTML = '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-3.1-3.1a2 2 0 0 0-2.8 0L6 21"/></svg>';
    }
    return frame;
  }

  function familyRule(rules, family) {
    return (((rules || {}).products) || []).filter(function (product) {
      return product.family === family;
    })[0] || null;
  }

  function filterUrlFor(rules, tags) {
    var base = (rules || {}).filterCollectionUrl || '/collections/all';
    return base + '/' + (tags || []).join('+');
  }

  function catalogMatches(catalog, tags) {
    return (catalog || []).filter(function (product) {
      return (tags || []).every(function (tag) {
        return (product.tags || []).indexOf(tag) !== -1;
      });
    });
  }

  function isMainProduct(product) {
    var tags = product.tags || [];
    return tags.indexOf('bundle') === -1 && tags.indexOf('accessory') === -1;
  }

  function featureMatchCount(product, featureTags) {
    return (featureTags || []).filter(function (tag) {
      return (product.tags || []).indexOf(tag) !== -1;
    }).length;
  }

  function recommendationOrderIndex(product, rule) {
    var order = (rule && rule.recommendationOrder) || [];
    var index = order.indexOf(product.handle || '');
    return index === -1 ? order.length + 1000 : index;
  }

  function rankCompatibleProducts(products, rule, featureTags) {
    var selectedTags = (featureTags || []).slice();
    return (products || []).map(function (product, index) {
      return {
        product: product,
        originalIndex: index,
        featureMatches: featureMatchCount(product, selectedTags),
        orderIndex: recommendationOrderIndex(product, rule),
        unavailable: product.available === false ? 1 : 0
      };
    }).sort(function (a, b) {
      if (a.unavailable !== b.unavailable) return a.unavailable - b.unavailable;
      if (selectedTags.length && a.featureMatches !== b.featureMatches) return b.featureMatches - a.featureMatches;
      if (a.orderIndex !== b.orderIndex) return a.orderIndex - b.orderIndex;
      return a.originalIndex - b.originalIndex;
    }).map(function (entry, index) {
      return Object.assign({}, entry.product, {
        recommendationRank: index + 1,
        selectedFeatureMatches: entry.featureMatches,
        selectedFeatureTotal: selectedTags.length
      });
    });
  }

  function productCard(product, root, result, state, placement) {
    placement = placement || {};
    var article = el('article', 'blusafe-compatibility__product-card');
    if (placement.best) {
      article.className += ' blusafe-compatibility__product-card--best';
      article.appendChild(el('span', 'blusafe-compatibility__best-badge', '#1 Best seller'));
    }
    if (placement.rank) article.setAttribute('data-recommendation-rank', String(placement.rank));
    if (product.image) {
      var imageWrap = el('div', 'blusafe-compatibility__product-media');
      var img = document.createElement('img');
      img.src = product.image;
      img.alt = product.title || 'Recommended Blusafe product';
      img.loading = 'lazy';
      imageWrap.appendChild(img);
      article.appendChild(imageWrap);
    }

    var body = el('div', 'blusafe-compatibility__product-body');
    if (!placement.best) body.appendChild(el('p', 'blusafe-compatibility__eyebrow', placement.label || 'Recommended product'));
    body.appendChild(el('h3', 'blusafe-compatibility__product-title', product.title || 'Blusafe product'));

    if (placement.note) body.appendChild(el('p', 'blusafe-compatibility__match-note', placement.note));

    if (product.price) body.appendChild(el('p', 'blusafe-compatibility__price', product.price));
    if (product.available === false) body.appendChild(el('p', 'blusafe-compatibility__warning', 'Currently unavailable to buy online.'));

    var actions = el('div', 'blusafe-compatibility__actions');
    if (product.url) {
      var link = el('a', 'bs-btn bs-btn--secondary bs-btn--md', 'View product');
      link.href = product.url;
      link.addEventListener('click', function () {
        track('product_clicked', {
          checker_type: 'main',
          market: 'uk',
          source_page: window.location.pathname,
          product_handle: product.handle || null,
          result_status: result.status,
          recommended_product_families: [product.family]
        });
      });
      actions.appendChild(link);
    }

    if (product.variantId && product.available !== false) {
      var button = el('button', 'bs-btn bs-btn--primary bs-btn--md', 'Add to cart');
      button.type = 'button';
      button.addEventListener('click', function () {
        button.disabled = true;
        button.textContent = 'Adding...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: product.variantId, quantity: 1 })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Add to cart failed');
            return response.json();
          })
          .then(function () {
            button.textContent = 'Added';
            track('add_to_cart_after_checker', {
              checker_type: 'main',
              market: 'uk',
              source_page: window.location.pathname,
              product_handle: product.handle || null,
              lock_type: state.answers.lockType || null,
              result_status: result.status,
              recommended_product_families: [product.family],
              missing_measurements: result.missingChecks || [],
              confidence_score: result.status === 'compatible' ? 100 : 70
            });
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          })
          .catch(function () {
            button.disabled = false;
            button.textContent = 'Try again';
          });
      });
      actions.appendChild(button);
    }

    body.appendChild(actions);
    article.appendChild(body);
    return article;
  }

  function renderPhotoBlock(root, compact) {
    var contactUrl = root.getAttribute('data-contact-url') || '/pages/contact';
    var block = el('aside', compact ? 'blusafe-compatibility__photo blusafe-compatibility__photo--compact' : 'blusafe-compatibility__photo');
    block.appendChild(el('h3', '', 'Send photos for review'));
    block.appendChild(el('p', '', 'Send us clear photos and we will confirm the best Blusafe option.'));
    var list = el('ol', '');
    ['Front of the lock or handle', 'Inside of the lock or handle', 'Door edge with the door open', 'Close-up of the latch, deadbolt or multipoint strip', 'Optional tape-measure photo'].forEach(function (item) {
      list.appendChild(el('li', '', item));
    });
    block.appendChild(list);

    function trackPhotoStart(channel) {
      track('photo_upload_started', {
        checker_type: compact ? 'mini' : 'main',
        market: 'uk',
        source_page: window.location.pathname,
        channel: channel
      });
    }

    var actions = el('div', 'blusafe-compatibility__photo-actions');
    var helpEmail = root.getAttribute('data-help-email') || '';
    var whatsappNumber = (root.getAttribute('data-whatsapp-number') || '').replace(/\D/g, '');
    var helpMessage = 'Hi Blusafe U.S. — I need help checking which lock fits my door. I will attach photos of my existing lock or handle and measurements. Page: ' + window.location.origin + window.location.pathname;

    if (helpEmail) {
      var emailLink = el('a', 'bs-btn bs-btn--primary bs-btn--md', 'Email us your photos');
      emailLink.href = 'mailto:' + helpEmail + '?subject=' + encodeURIComponent('Will it fit my door?') + '&body=' + encodeURIComponent(helpMessage);
      emailLink.addEventListener('click', function () { trackPhotoStart('email'); });
      actions.appendChild(emailLink);
    }

    if (whatsappNumber) {
      var whatsappLink = el('a', 'bs-btn bs-btn--md blusafe-compatibility__whatsapp', 'Send photos on WhatsApp');
      whatsappLink.href = 'https://wa.me/' + whatsappNumber + '?text=' + encodeURIComponent(helpMessage);
      whatsappLink.target = '_blank';
      whatsappLink.rel = 'noopener';
      whatsappLink.addEventListener('click', function () { trackPhotoStart('whatsapp'); });
      actions.appendChild(whatsappLink);
    }

    var link = el('a', (helpEmail || whatsappNumber) ? 'bs-btn bs-btn--secondary bs-btn--md' : 'bs-btn bs-btn--primary bs-btn--md', 'Send photos instead');
    link.href = contactUrl;
    link.addEventListener('click', function () { trackPhotoStart('contact_page'); });
    actions.appendChild(link);

    block.appendChild(actions);
    return block;
  }

  function initChecker(root) {
    var body = root.querySelector('[data-compatibility-body]');
    var progress = root.querySelector('[data-compatibility-progress]');
    var startButtons = Array.prototype.slice.call(root.querySelectorAll('[data-compatibility-start]'));
    var photoButtons = Array.prototype.slice.call(root.querySelectorAll('[data-compatibility-photo-start]'));
    var products = readJson(root, '[data-compatibility-products]', []);
    var catalog = readJson(root, '[data-compatibility-catalog]', []);
    var images = readJson(root, '[data-compatibility-images]', {});
    var contactUrl = root.getAttribute('data-contact-url') || '/pages/contact';
    var rulesUrl = root.getAttribute('data-rules-url');
    var state = {
      answers: {},
      family: '',
      questionIndex: 0,
      history: [],
      started: false
    };

    function save() {
      try {
        window.sessionStorage.setItem('blusafeCompatibilityMain', JSON.stringify(state.answers));
      } catch (error) {
        // Session storage is optional.
      }
    }

    function setProgress(text, percent) {
      if (!progress) return;
      clear(progress);
      if (!text) return;
      progress.appendChild(el('span', 'blusafe-compatibility__progress-label', text));
      if (typeof percent === 'number') {
        var bar = el('span', 'blusafe-compatibility__progress-bar', '');
        var fill = el('span', 'blusafe-compatibility__progress-fill', '');
        fill.style.width = Math.max(6, Math.round(percent * 100)) + '%';
        bar.appendChild(fill);
        progress.appendChild(bar);
      }
    }

    function scrollToPanel() {
      if (!state.started) return;
      var panel = root.querySelector('.blusafe-compatibility__panel');
      if (!panel) return;
      var top = Math.max(0, panel.getBoundingClientRect().top + window.pageYOffset - 84);
      if (Math.abs(window.pageYOffset - top) > 24) {
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    }

    function renderActions(canGoBack) {
      var actions = el('div', 'blusafe-compatibility__nav');
      if (canGoBack) {
        var back = el('button', 'bs-btn bs-btn--secondary bs-btn--md', 'Back');
        back.type = 'button';
        back.addEventListener('click', function () {
          var snapshot = state.history.pop();
          if (snapshot) {
            state.answers = snapshot.answers;
            state.family = snapshot.family;
            state.questionIndex = snapshot.questionIndex;
            snapshot.render();
          }
        });
        actions.appendChild(back);
      }
      var restart = el('button', 'bs-btn bs-btn--secondary bs-btn--md', 'Start over');
      restart.type = 'button';
      restart.addEventListener('click', renderLockTypes);
      actions.appendChild(restart);

      var photo = el('a', 'bs-btn bs-btn--secondary bs-btn--md', 'Send photos instead');
      photo.href = contactUrl;
      photo.addEventListener('click', function () {
        track('photo_upload_started', {
          checker_type: 'main',
          market: 'uk',
          source_page: window.location.pathname,
          lock_type: state.answers.lockType || null
        });
      });
      actions.appendChild(photo);
      return actions;
    }

    function evaluateAndRender(rules) {
      var result = window.BlusafeCompatibility.evaluate({
        mode: 'main',
        productHandle: null,
        answers: state.answers,
        products: products
      });
      renderResult(result, rules);
      track('result_seen', {
        checker_type: 'main',
        market: 'uk',
        source_page: window.location.pathname,
        product_handle: null,
        lock_type: state.answers.lockType || null,
        result_status: result.status,
        recommended_product_families: result.recommendedProducts.map(function (product) { return product.family; }),
        missing_measurements: result.missingChecks,
        confidence_score: result.status === 'compatible' ? 100 : result.status === 'probably_compatible' ? 70 : 30
      });
      return rules;
    }

    function applyOption(question, option, renderCurrent) {
      state.history.push({
        answers: Object.assign({}, state.answers),
        family: state.family,
        questionIndex: state.questionIndex,
        render: renderCurrent
      });
      state.answers[question.id] = option.value;
      if (option.sets) {
        Object.keys(option.sets).forEach(function (key) {
          state.answers[key] = option.sets[key];
        });
      }
      save();

      track('measurement_answered', {
        checker_type: 'main',
        market: 'uk',
        source_page: window.location.pathname,
        lock_type: state.answers.lockType || null,
        question_id: question.id,
        answer: option.value
      });

      fetchJson(rulesUrl).then(function (rules) {
        var nextFamily = window.BlusafeCompatibility.familyForLockType(state.answers.lockType);
        if (nextFamily && nextFamily !== state.family) {
          state.family = nextFamily;
          state.questionIndex = 0;
          renderQuestion(rules);
          return;
        }

        var probe = window.BlusafeCompatibility.evaluate({
          mode: 'main',
          productHandle: null,
          answers: state.answers,
          products: products
        });
        if (probe.status === 'not_compatible') {
          renderResult(probe, rules);
          track('result_seen', {
            checker_type: 'main',
            market: 'uk',
            source_page: window.location.pathname,
            product_handle: null,
            lock_type: state.answers.lockType || null,
            result_status: probe.status,
            recommended_product_families: probe.recommendedProducts.map(function (product) { return product.family; }),
            missing_measurements: probe.missingChecks,
            confidence_score: 30
          });
          return;
        }

        var questions = (rules.mainQuestions || {})[state.family] || [];
        if (state.questionIndex >= questions.length - 1) {
          state.answers.features = [];
          save();
          evaluateAndRender(rules);
          return;
        }

        state.questionIndex += 1;
        renderQuestion(rules);
      });
    }

    function renderQuestion(rules) {
      clear(body);
      var questions = (rules.mainQuestions || {})[state.family] || [];
      var question = questions[state.questionIndex];
      if (!question) {
        evaluateAndRender(rules);
        return;
      }

      var step = state.questionIndex + 2;
      var total = questions.length + 1;
      setProgress('Step ' + step + ' of ' + total, step / (total + 1));
      var shell = el('div', 'blusafe-compatibility__question');
      shell.appendChild(el('p', 'blusafe-compatibility__eyebrow', 'A few checks'));
      shell.appendChild(el('h2', 'blusafe-compatibility__question-title', question.text));
      if (question.help) shell.appendChild(el('p', 'blusafe-compatibility__help-text', question.help));

      var questionBody = el('div', question.imageKey ? 'blusafe-compatibility__question-body blusafe-compatibility__question-body--split' : 'blusafe-compatibility__question-body');

      var options = el('div', 'blusafe-compatibility__options');
      (question.options || []).forEach(function (option) {
        var button = el('button', 'blusafe-compatibility__option', '');
        button.type = 'button';
        button.appendChild(el('span', 'blusafe-compatibility__option-mark', ''));
        button.appendChild(el('span', 'blusafe-compatibility__option-label', option.label));
        button.addEventListener('click', function () {
          applyOption(question, option, function () { renderQuestion(rules); });
        });
        options.appendChild(button);
      });

      questionBody.appendChild(options);
      if (question.imageKey) {
        questionBody.appendChild(mediaFrame(images, question.imageKey, question.text));
      }
      shell.appendChild(questionBody);
      shell.appendChild(renderActions(true));
      body.appendChild(shell);
      var firstButton = body.querySelector('button');
      if (firstButton) firstButton.focus({ preventScroll: true });
      scrollToPanel();
    }

    function chooseLockType(lockType, rules) {
      if (!state.started) {
        state.started = true;
        track('checker_start', {
          checker_type: 'main',
          market: 'uk',
          source_page: window.location.pathname
        });
      }

      state.history.push({
        answers: Object.assign({}, state.answers),
        family: state.family,
        questionIndex: state.questionIndex,
        render: renderLockTypes
      });
      state.answers = { lockType: lockType.id };
      state.family = window.BlusafeCompatibility.familyForLockType(lockType.id);
      state.questionIndex = 0;
      save();

      track('lock_type_selected', {
        checker_type: 'main',
        market: 'uk',
        source_page: window.location.pathname,
        lock_type: lockType.id
      });

      if (lockType.id === 'unknown') {
        evaluateAndRender(rules);
        return;
      }
      renderQuestion(rules);
    }

    function renderLockTypes() {
      fetchJson(rulesUrl).then(function (rules) {
        window.BlusafeCompatibility.setRules(rules);
        state.answers = {};
        state.family = '';
        state.questionIndex = 0;
        state.history = [];
        save();
        clear(body);
        setProgress('Step 1 of 4', 0.2);

        var shell = el('div', 'blusafe-compatibility__question');
        shell.appendChild(el('p', 'blusafe-compatibility__eyebrow', 'Find your setup'));
        shell.appendChild(el('h2', 'blusafe-compatibility__question-title', 'What does your current lock look like?'));
        shell.appendChild(el('p', 'blusafe-compatibility__help-text', 'Choose the option that looks closest. You can send photos at any point.'));

        var grid = el('div', 'blusafe-compatibility__lock-grid');
        (rules.lockTypes || []).forEach(function (lockType) {
          var button = el('button', 'blusafe-compatibility__lock-card', '');
          button.type = 'button';
          button.setAttribute('data-lock-type', lockType.id);
          button.appendChild(mediaFrame(images, lockType.imageKey, lockType.title));
          var copy = el('span', 'blusafe-compatibility__lock-copy');
          copy.appendChild(el('strong', '', lockType.title));
          copy.appendChild(el('span', '', lockType.subtitle));
          button.appendChild(copy);
          button.addEventListener('click', function () {
            chooseLockType(lockType, rules);
          });
          grid.appendChild(button);
        });

        shell.appendChild(grid);
        shell.appendChild(renderActions(false));
        body.appendChild(shell);
        scrollToPanel();
      });
    }

    function renderResult(result, rules) {
      clear(body);
      setProgress('Result', 1);
      var shell = el('div', 'blusafe-compatibility__result-card blusafe-compatibility__result-card--' + result.status);
      var eyebrow = el('p', 'blusafe-compatibility__eyebrow', statusLabel(result.status));
      var resultTitle = el('h2', 'blusafe-compatibility__result-title', statusCopy(result.status));
      shell.appendChild(eyebrow);
      shell.appendChild(resultTitle);

      var reasons = (result.reasons || []).concat(result.missingChecks || [], result.warnings || []);
      if (reasons.length) {
        var list = el('ul', 'blusafe-compatibility__reason-list');
        reasons.forEach(function (reason) {
          list.appendChild(el('li', '', reason));
        });
        shell.appendChild(list);
      }

      if (result.accessoryRecommendations && result.accessoryRecommendations.length) {
        var accessory = el('div', 'blusafe-compatibility__callout');
        accessory.appendChild(el('strong', '', 'Accessory recommendation'));
        result.accessoryRecommendations.forEach(function (item) {
          accessory.appendChild(el('p', '', item.title + ': ' + item.reason));
        });
        shell.appendChild(accessory);
      }

      var resolvedFamily = state.family || (result.recommendedProducts[0] || {}).family || '';
      var resolvedRule = familyRule(rules, resolvedFamily);
      var showFilterResults = result.status === 'compatible' || result.status === 'probably_compatible';
      var displayedProducts = [];
      if (showFilterResults && resolvedRule && resolvedRule.filterTags && resolvedRule.filterTags.length) {
        var featureTags = (state.answers.features || []).slice();
        var allMatches = catalogMatches(catalog, resolvedRule.filterTags);
        var bundleMatches = allMatches.filter(function (product) {
          return (product.tags || []).indexOf('bundle') !== -1;
        });
        var mainMatches = allMatches.filter(isMainProduct);
        var catalogProducts = mainMatches.length ? mainMatches : allMatches;
        var compatibleProducts = catalogProducts.length ? catalogProducts : (result.recommendedProducts || []);
        var rankedProducts = rankCompatibleProducts(compatibleProducts, resolvedRule, featureTags);
        if (rankedProducts.length) {
          displayedProducts = rankedProducts.slice();
          var browseUrl = filterUrlFor(rules, resolvedRule.filterTags);

          var filterBlock = el('div', 'blusafe-compatibility__filter-results');
          filterBlock.appendChild(el('h3', 'blusafe-compatibility__filter-results-title', 'All compatible products, ranked'));
          var resultSummary = 'We found ' + rankedProducts.length + (rankedProducts.length === 1
            ? ' product that fits this door setup.'
            : ' products that fit this door setup. Our best seller is shown first, followed by every other compatible option.');
          filterBlock.appendChild(el('p', 'blusafe-compatibility__help-text', resultSummary));

          var rankedUrl = browseUrl + (browseUrl.indexOf('?') === -1 ? '?' : '&') + 'bs_ranked=1';
          function browseAllButton(extraClass) {
            var browse = el('a', 'bs-btn bs-btn--primary bs-btn--md blusafe-compatibility__filter-browse' + (extraClass ? ' ' + extraClass : ''), 'Search all ' + rankedProducts.length + ' compatible product' + (rankedProducts.length === 1 ? '' : 's'));
            browse.href = rankedUrl;
            browse.addEventListener('click', function () {
              track('checker_filter_browse', {
                checker_type: 'main',
                market: 'uk',
                source_page: window.location.pathname,
                lock_type: state.answers.lockType || null,
                result_status: result.status,
                filter_tags: resolvedRule.filterTags,
                filter_url: browseUrl,
                match_count: rankedProducts.length
              });
            });
            return browse;
          }

          if (catalogProducts.length) {
            try {
              window.sessionStorage.setItem('blusafeCheckerRank', JSON.stringify({
                handles: rankedProducts.map(function (product) { return product.handle; }),
                family: resolvedFamily,
                features: featureTags
              }));
            } catch (error) {
              // Session storage is optional.
            }
            filterBlock.appendChild(browseAllButton('blusafe-compatibility__filter-browse--top'));
          }

          filterBlock.appendChild(productCard(Object.assign({ family: resolvedFamily }, rankedProducts[0]), root, result, state, {
            best: true,
            rank: 1,
            label: 'Best seller',
            note: 'Our best seller for this door setup.'
          }));

          if (rankedProducts.length > 1) {
            filterBlock.appendChild(el('h4', 'blusafe-compatibility__others-title', 'Other compatible options'));
            var productGrid = el('div', 'blusafe-compatibility__product-grid');
            rankedProducts.slice(1).forEach(function (product, index) {
              productGrid.appendChild(productCard(Object.assign({ family: resolvedFamily }, product), root, result, state, {
                best: false,
                rank: index + 2,
                label: 'Compatible option ' + (index + 2),
                note: 'Also compatible with this door setup.'
              }));
            });
            filterBlock.appendChild(productGrid);
          }

          if (catalogProducts.length) {
            filterBlock.appendChild(browseAllButton(''));

            if (bundleMatches.length && mainMatches.length) {
              var bundlesUrl = filterUrlFor(rules, resolvedRule.filterTags.concat(['bundle']));
              var bundlesLink = el('a', 'bs-btn bs-btn--tertiary bs-btn--md blusafe-compatibility__filter-browse', 'Prefer a bundle? See ' + bundleMatches.length + ' compatible bundle' + (bundleMatches.length === 1 ? '' : 's'));
              bundlesLink.href = bundlesUrl;
              bundlesLink.addEventListener('click', function () {
                track('checker_filter_browse', {
                  checker_type: 'main',
                  market: 'uk',
                  source_page: window.location.pathname,
                  lock_type: state.answers.lockType || null,
                  result_status: result.status,
                  filter_tags: resolvedRule.filterTags.concat(['bundle']),
                  filter_url: bundlesUrl,
                  match_count: bundleMatches.length
                });
              });
              filterBlock.appendChild(bundlesLink);
            }
          }
          shell.appendChild(filterBlock);
        }
      }

      if (!displayedProducts.length && result.recommendedProducts && result.recommendedProducts.length) {
        var fallbackGrid = el('div', 'blusafe-compatibility__product-grid');
        result.recommendedProducts.forEach(function (product, index) {
          fallbackGrid.appendChild(productCard(product, root, result, state, {
            best: index === 0,
            rank: index + 1,
            label: index === 0 ? 'Best match' : 'Compatible option ' + (index + 1)
          }));
        });
        shell.appendChild(fallbackGrid);
        displayedProducts = result.recommendedProducts.slice();
      }

      if (result.status === 'not_compatible' && !displayedProducts.length) {
        eyebrow.textContent = 'Not the right fit';
        resultTitle.textContent = 'This lock family will not fit your door.';
        var nextSteps = el('div', 'blusafe-compatibility__filter-results');
        nextSteps.appendChild(el('h3', 'blusafe-compatibility__filter-results-title', 'What to do next'));
        nextSteps.appendChild(el('p', 'blusafe-compatibility__help-text', 'Start over and pick the option that looks closest to your door, or send us photos and we will recommend the right product for you.'));
        var browseAll = el('a', 'bs-btn bs-btn--secondary bs-btn--md', 'Browse all smart locks');
        browseAll.href = (rules && rules.filterCollectionUrl) || '/collections/all';
        browseAll.addEventListener('click', function () {
          track('checker_filter_browse', {
            checker_type: 'main',
            market: 'uk',
            source_page: window.location.pathname,
            lock_type: state.answers.lockType || null,
            result_status: result.status,
            filter_tags: [],
            filter_url: browseAll.getAttribute('href'),
            match_count: 0
          });
        });
        nextSteps.appendChild(browseAll);
        shell.appendChild(nextSteps);
      }

      shell.appendChild(renderPhotoBlock(root, false));
      shell.appendChild(renderActions(true));
      body.appendChild(shell);
      scrollToPanel();
      return displayedProducts;
    }

    startButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (!state.started) {
          state.started = true;
          track('checker_start', {
            checker_type: 'main',
            market: 'uk',
            source_page: window.location.pathname
          });
        }
        renderLockTypes();
        var panel = root.querySelector('.blusafe-compatibility__panel');
        if (panel) {
          var top = Math.max(0, panel.getBoundingClientRect().top + window.pageYOffset - 90);
          window.scrollTo({ top: top, behavior: 'smooth' });
          window.setTimeout(function () {
            if (Math.abs(window.pageYOffset - top) > 40) window.scrollTo(0, top);
          }, 450);
        }
      });
    });

    photoButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        track('photo_upload_started', {
          checker_type: 'main',
          market: 'uk',
          source_page: window.location.pathname
        });
      });
    });

    if (body && !body.children.length) {
      renderLockTypes();
    }
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-compatibility-checker]')).forEach(initChecker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
